import request from '@/utils/request'

let BalanceApi = {
  /*编辑*/
  getSetting(data) {
    return request._get('/shop/plus.balance.setting/index', data);
  },

  /*编辑*/
  saveSetting(data) {
    return request._post('/shop/plus.balance.setting/index', data);
  },

    getcallSetting(data) {
    return request._get('/shop/plus.balance.setting/getcallSetting', data);
  },
    savcallSetting(data) {
    return request._post('/shop/plus.balance.setting/getcallSetting', data);
  },
}

export default BalanceApi;



// WEBPACK FOOTER //
// ./src/api/balance.js